import * as React from 'react';
import { PaymentInstructionLayout } from '../../component/PaymentInstructionLayout.js';

const Paypal = ()=>{
    return /*#__PURE__*/ React.createElement(PaymentInstructionLayout, {
        info: "checkout.payment.method.paypal.info"
    });
};

export { Paypal };
//# sourceMappingURL=Paypal.js.map
